import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEN from '../locales/en/common.json';

import commonTL from '../locales/tl/common.json';;

i18n.use(initReactI18next).init({
    resources: {
        en: {
        common: commonEN,
        },
        tl: {
        common: commonTL,
        },
    },
    lng: 'en',
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
});

export default i18n;
